import _ from 'lodash'
import { cleanLocationSettingsDisplay } from './clean-location-settings-displays'
import { cleanPrintTo } from './clean-print-to'

export function cleanDisplays (menuBlob, settingsBlob) {
  _.eachRight(_.get(menuBlob, 'displays', []), display => {
    cleanPrintTo(display, menuBlob)
    cleanLocationSettingsDisplay(display, menuBlob, settingsBlob)
  })
}
